/**
 * ブランド用スライダーのイニシャライズ
 * @param {String} id イニシャライズするスライダーのID
 */
function initializeBrandSlide(id) {
  if (document.getElementById(id)) {
    const swiper = new Swiper(`#${id}`, {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        waitForTransition: false,
      },

      pagination: {
        el: `#${id} .js_brandSlidePagination`,
      },

      navigation: {
        prevEl: `#${id} .js_brandSlidePrev`,
        nextEl: `#${id} .js_brandSlideNext`,
      },
    });
  }
}

/**
 * アコーディオン
 */
{
  document.addEventListener('DOMContentLoaded', function() {
    const accordionHeads = document.querySelectorAll('.js_accordionHead');
    accordionHeads.forEach(head => {
      head.addEventListener('click', function() {
        const container = head.closest('.js_accordionContainer');
        const body = container.querySelector('.js_accordionBody');
        if (head.classList.contains('is_open')) {
          head.classList.remove('is_open')
          body.classList.add('hp_hidden');
        } else {
          head.classList.add('is_open')
          body.classList.remove('hp_hidden');
        }
      });
    });
  });
}